<div class="modal__content">
    <form class="form" @submit.prevent="activeValidation = true; onSubmit();">
        <div class="form__group nopad">
            <div class="usp">
                <span>
                    <i class="fa-solid fa-check" />
                    {{ $t('modals.register.usp-1') }}
                </span>
                <span>
                    <i class="fa-solid fa-check" />
                    {{ $t('modals.register.usp-2') }}
                </span>
                <span>
                    <i class="fa-solid fa-check" />
                    {{ $t('modals.register.usp-3') }}
                </span>
            </div>
        </div>
        <h2>{{ $t('modals.register.title') }}</h2>
        <div class="form__group">
            <label v-t="'modals.register.username'"></label>
            <input :class="{alert: errors.username && activeValidation}" :disabled='isSubmitting' type="text" name="username" v-model="username" :placeholder="$t('modals.register.username-placeholder')" />
            <div class="form__group-alert" v-if="errors.username && activeValidation" v-t="'modals.register.alerts.errorNoValidUsername'"></div>
        </div>
        <div class="form__group">
            <label v-t="'modals.register.email'"></label>
            <input :class="{alert: errors.email && activeValidation}" :disabled='isSubmitting' type="text" name="email" v-model="email" :placeholder="$t('modals.register.email-placeholder')" autocorrect="off" autocapitalize="none" />
            <div class="form__group-alert" v-if="errors.email && activeValidation" v-t="'modals.register.alerts.errorNoValidEmail'"></div>
        </div>
        <div class="form__group">
            <label v-t="'modals.register.password'"></label>
            <input :class="{alert: errors.password && activeValidation}" :disabled='isSubmitting' type="password" name="password" v-model="password" :placeholder="$t('modals.register.password-placeholder')" />
            <div class="form__group-alert" v-if="errors.password && activeValidation" v-t="'modals.register.alerts.errorNoValidPassword'"></div>
        </div>
        <div class="form__group">              
            <button :disabled='isSubmitting' type="submit" class="btn btn-full" v-t="'modals.register.title'" >    
            </button>
        </div>
        <div class="form__group nopad">
            <h3>{{ $t('modals.register.allreadyacc') }}</h3>
        </div>
        <div class="form__group nopad">
            <a class="btn btn-green" href="#" @click="doLogin()">{{ $t('modals.login.title') }}</a>
        </div>
    </form>
</div>
